// Navbar.js
import React, { useState, useEffect } from 'react';
import './navbar.css';

const Navbar = () => {
  const [prevScrollPos, setPrevScrollPos] = useState(window.pageYOffset);
  const [visible, setVisible] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleScroll = () => {
    const currentScrollPos = window.pageYOffset;
    setVisible(prevScrollPos > currentScrollPos);
    setPrevScrollPos(currentScrollPos);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [prevScrollPos, visible]);

  return (
    <nav className={`navbar ${visible ? 'visible' : 'hidden'}`}>
      <div className="navbar-container">
        {/* <div className="logo">Your Logo</div> */}
        <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`} onClick={toggleMobileMenu}>
        <div className={`bar ${isMobileMenuOpen ? 'rotate-left' : ''}`} />
        <div className={`bar ${isMobileMenuOpen ? 'hide' : ''}`} />
        <div className={`bar ${isMobileMenuOpen ? 'rotate-right' : ''}`} />
      </div>
        <ul className={`nav-links ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <li>
            <a href="#about" className="nav-link" >
              Home
            </a>
          </li>
          <li>
            <a href="#projects" className="nav-link" >
              Projects
            </a>
          </li>
          <li>
            <a href="#skills" className="nav-link" >
              Skills
            </a>
          </li>
          <li>
            <a href="#education" className="nav-link" >
              Education
            </a>
          </li>
          <li>
            <a href="#contact" className="nav-link" >
              Contact
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
